import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./level2FilterSection.html";
import { isL2OptionChangeEventDetail, isL2OptionEventDetail } from 'search/level2FilterOption';
import { isOptionChecked } from '~/modules/helpers/searchSortOptionsHelper';
import { isL2Option } from '~/modules/stores/searchFiltersStore';
class Level2FilterSection extends LightningElement {
  constructor(...args) {
    super(...args);
    this._radioOptions = new Map();
    this._multiple = false;
  }
  set section(section) {
    const radioOptions = new Map();
    for (const option of section.options) {
      if (isL2Option(option)) {
        const item = {
          ...option,
          checked: isOptionChecked(section.selectedValue, option)
        };
        item.childSelectedValues = [];
        // @ts-expect-error * Automated Type Error Fix
        for (const l2option of option.options) {
          if (isOptionChecked(section.selectedValue, l2option)) {
            item.childSelectedValues.push(l2option.value);
          }
        }
        radioOptions.set(option.value, item);
      } else {
        radioOptions.set(option.value, {
          ...option,
          checked: isOptionChecked(section.selectedValue, option)
        });
      }
    }
    this._radioOptions = radioOptions;
    this._section = section;
  }
  get section() {
    return this._section;
  }
  get multiple() {
    return this.section.type === 'multiLevel';
  }
  get options() {
    return Array.from(this._radioOptions.values());
  }
  get selectedValue() {
    return this.section.selectedValue;
  }
  selectedOptions() {
    // We need to gather the selection state of the whole section, including the children options if it is a multilevel
    // if the section is not a multilevel option, then return only the selected value
    return Array.from(this._radioOptions.values()).reduce((options, option) => {
      if (option.checked) {
        // @ts-expect-error * Automated Type Error Fix
        options.push(option.value);
      }
      if (option.options) {
        // @ts-expect-error * Automated Type Error Fix
        options.push(...option.childSelectedValues);
      }
      return options;
    }, []);
  }
  handleChange(event) {
    event.stopPropagation();
    const parentItem = this._radioOptions.get(event.detail.parentValue);
    if (parentItem && isL2OptionChangeEventDetail(event.detail)) {
      const {
        childSelectedValues,
        parentChecked
      } = event.detail;
      parentItem.checked = childSelectedValues.length === 0 && parentChecked;
      parentItem.childSelectedValues = childSelectedValues;
    } else if (isL2OptionEventDetail(event.detail)) {
      // @ts-expect-error * Automated Type Error Fix
      parentItem.checked = event.detail.parentChecked;
      // @ts-expect-error * Automated Type Error Fix
      parentItem.childSelectedValues = [];
    }
    this.dispatchEvent(new CustomEvent('filterchange', {
      detail: {
        section: this._section.name,
        value: this.selectedOptions()
      },
      composed: true,
      bubbles: true,
      cancelable: true
    }));
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Level2FilterSection, {
  publicProps: {
    section: {
      config: 3
    }
  },
  fields: ["_radioOptions", "_multiple"]
});
const __lwc_component_class_internal = _registerComponent(Level2FilterSection, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;